<template>
  <div class="more-like-this-container">
    <div class="d-flex justify-start">
      <h3 class="pa-3">
        {{ $t('views.journal.searchSimilar.title', { documentTitle: documentDetails.title }) }}
      </h3>
      <div class="more-like-this-menu">
        <div class="d-flex align-center">
          <v-icon
            style="width: 24px; height: 24px;"
            v-if="!moreLikeThisLoading"
            size="32"
            @click.stop.prevent.exact="closeMoreLikeThis"
          >
            close
          </v-icon>
        </div>
        <div class="d-flex align-center">
          <v-progress-circular
            indeterminate
            v-if="moreLikeThisLoading"
            class="mx-3"
            size="20"
            width="2"
          />
        </div>
      </div>
    </div>
    <DocumentCardIterator :items="recommendations">
      <template v-slot:item="{ item }">
        <slot
          name="item"
          :item="item"
        />
      </template>
    </DocumentCardIterator>
    <!-- TODO implement more results for similar search... use pagination? -->
    <!-- <div class="d-flex justify-center">
      <div class="show-more px-4 py-2">
        <span
          disabled
          text
          plain
          color="primary"
        >
          {{ $t('views.journal.searchSimilar.more') }}
        </span>
      </div>
    </div> -->
    <v-divider class="mt-4" />
  </div>
</template>

<script>
import { NoosAssistantSearch } from '../../search/SearchUtils';
import DocumentCardIterator from '../DocumentCardIterator';

export default {
  name: 'MoreLikeThis',
  components: {
    DocumentCardIterator,
  },
  data: () => ({
    recommendations: [],
  }),
  props: {
    documentDetails: {
      type: Object,
      required: true,
    },
    showEvaluation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    moreLikeThisLoading() {
      if (this.recommendations.length === 0) return true;

      return false;
    },
  },
  methods: {
    closeMoreLikeThis() {
      this.$emit('close');
    },
    async generateMoreLikeThis() {
      this.moreLikeThisShow = true;
      if (this.recommendations.length > 0) return;

      const generator = new NoosAssistantSearch();
      const response = await generator.fromDocument(this.documentDetails).fetchResults();
      this.recommendations = response.items.map(item => ({
        documentId: item.documentId,
        documentDetails: {
          recommendation: { },
          ...item.document,
          documentType: 'document',
        },
      }));
    },
  },
};
</script>
<style scope>
.more-like-this-container {
  display: block;
  width: 100%;
}
.more-like-this-menu {
  display: flex;
  justify-content: flex-start;
  width: 128px;
}
.show-more {
  background-color: white;
  border-radius: 18px;
  margin: 12px;
}
</style>
